import { flow } from "fp";
import { QueryKey } from "react-query";

import { ID } from "~/Data";
import * as Preferences from "~/Preferences";
import { Request } from "~/Request";

type UserQueryParam = {
  readonly id: ID.ID;
};

const elogsClientAppId = "4";

export const toEndpoint = ({ id }: UserQueryParam) =>
  `/users/${id}/preferences?client_application_id=${elogsClientAppId}`;

export namespace Query {
  export const tag = () => "User Preferences" as const;

  export const key = (id: UserQueryParam): QueryKey => [tag(), id];

  export namespace Get {
    export const request = <T extends unknown>({
      id,
    }: UserQueryParam): Request.Fn<Preferences.UserPreferences<T>> => {
      const endpoint = toEndpoint({ id });
      return flow(
        Request.fromConfig({ endpoint }),
        Request.Expect.status(200),
        Request.Expect.json(Preferences.Response.runtime()),
        Request.onSuccess((p) => Preferences.Response.decode<T>(p))
      );
    };
  }

  export namespace Put {
    export type preferencesPutParams = UserQueryParam & {
      readonly preferences: unknown;
    };
    export const request = ({
      id,
      preferences,
    }: preferencesPutParams): Request.Fn => {
      const endpoint = toEndpoint({ id });
      return flow(
        Request.fromConfig({
          endpoint,
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: `{ "preferences": ${JSON.stringify(preferences)}, "client_application_id": "${elogsClientAppId}"}`,
        }),
        Request.Expect.status(204)
      );
    };
  }
}
